<div class="flex flex-col gap-4">
  <!-- One-time warning: the secret cannot be retrieved again -->
  <div class="flex items-start gap-2 p-3 rounded-xl border border-amber-200 bg-amber-50 text-amber-700">
    <span class="pi pi-exclamation-triangle mt-0.5 shrink-0 text-sm" aria-hidden="true"></span>
    <span class="text-sm">{{ 'licence-server.credentials-warning' | translate }}</span>
  </div>

  <!-- Client id -->
  <div class="flex flex-col gap-1">
    <span class="text-xs uppercase tracking-wide text-surface-400">{{ 'licence-server.client-id' | translate }}</span>
    <div class="flex items-center gap-2 p-2.5 rounded-xl border border-primary-50 bg-[var(--p-surface-50)]">
      <span class="flex-1 min-w-0 truncate font-mono text-sm">{{ credentials().clientId }}</span>
      <elcia-icon
        (onClick)="copyClientId()"
        [iconType]="clientIdCopied() ? 'check' : 'copy'"
        class="cursor-pointer shrink-0 text-surface-400 hover:text-surface-600"
        iconSize="sm"/>
    </div>
  </div>

  <!-- Client secret -->
  <div class="flex flex-col gap-1">
    <span class="text-xs uppercase tracking-wide text-surface-400">{{ 'licence-server.client-secret' | translate }}</span>
    <div class="flex items-center gap-2 p-2.5 rounded-xl border border-primary-50 bg-[var(--p-surface-50)]">
      <span class="flex-1 min-w-0 break-all font-mono text-sm">{{ credentials().clientSecret }}</span>
      <elcia-icon
        (onClick)="copyClientSecret()"
        [iconType]="clientSecretCopied() ? 'check' : 'copy'"
        class="cursor-pointer shrink-0 text-surface-400 hover:text-surface-600"
        iconSize="sm"/>
    </div>
  </div>
</div>
